import React from 'react';

export const RestaurantListPage = () => {

	return (
		<div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>

			<img src='/images/poweredBy/tablz.svg' height='auto' style={{ minHeight: '200px' }} width='50%' alt='Tablz' />
		</div>
	);
};